import React from 'react';

const GoogleDriveVideo = ({ videoUrl, teamName }) => {
    // Function to extract the file ID from various Google Drive URL formats
    const getGoogleDriveFileId = (url) => {
        if (!url) return null;
        
        // Handle different Google Drive URL formats
        const patterns = [
            /\/file\/d\/([a-zA-Z0-9-_]+)/,  // Format: https://drive.google.com/file/d/FILE_ID/view
            /id=([a-zA-Z0-9-_]+)/,           // Format: https://drive.google.com/open?id=FILE_ID
            /\/d\/([a-zA-Z0-9-_]+)/,         // Format: https://drive.google.com/uc?id=FILE_ID&export=download
        ];
        
        for (const pattern of patterns) {
            const match = url.match(pattern);
            if (match && match[1]) {
                return match[1];
            }
        }
        
        return null;
    };

    const fileId = getGoogleDriveFileId(videoUrl);
    
    if (!fileId) {
        return null;
    }

    // Create the embed URL for Google Drive video
    const embedUrl = `https://drive.google.com/file/d/${fileId}/preview`;

    return (
        <div style={{
            position: 'relative',
            paddingBottom: '56.25%', // 16:9 aspect ratio
            height: 0,
            overflow: 'hidden',
            maxWidth: '100%',
            background: '#000',
            borderRadius: '10px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
            <iframe
                src={embedUrl}
                title={`${teamName} Fundraiser Video`}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 'none'
                }}
                allow="autoplay"
                allowFullScreen
            />
        </div>
    );
};

export default GoogleDriveVideo; 